// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"505":"1893c047","840":"e3f64736"}[chunkId] + ".chunk.js";
};